
// region JS Imports

// region External Modules
import _template from "lodash/template"
// endregion External Modules

// region Private Modules
import I18n from "plugins/i18n-js"

import Highcharts from "plugins/highcharts"
// endregion Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import legend_template from "./legend.html._tpl"
import tooltip_template from "./tooltip.html._tpl"
// endregion Private Components

// endregion JS Imports

const legend_tmpl = _template(legend_template)
const tooltip_tmpl = _template(tooltip_template)
const chart_title_width = 80
const point_colors_collection = [
  "#192673",
  "#2773B8",
  "#53BACE",
  "#9ACEC8",
  "#BAE0C6",
  "#E7E9B3",
  "#FFE6AA",
  "#F5F4F4",
]

function data_to_be_used(chart_name: string, data: any) {
  if (chart_name === "distribution") {
    return data.transaction_distribution_breakdown
  }
  else if (chart_name === "area"){
    return data.transaction_area_breakdown
  }
  else if (chart_name === "price_per_sqft") {
    return data.transaction_price_per_area_breakdown
  }
  else if (chart_name === "price") {
    return data.transaction_price_breakdown
  }
}

const create = ($pie_chart_container: JQuery<HTMLElement>, data: any, chart_name: string): any => {
  // @ts-ignore
  const $target_pie_chart_container = $pie_chart_container.filter(`[type=${chart_name}]`)

  const title_translation = I18n.t(`apps_spacious_website_pages.building_level_real_estate_transaction_list_page.sections.overview.pie_charts.title.${chart_name}`)
  const data_collection = data_to_be_used(chart_name, data)

  // @ts-ignore
  Highcharts.chart($target_pie_chart_container[0] as Highcharts.HTMLDOMElement, {
    chart: {
      animation:  false,
      plotShadow: false,
      type:       "pie",
      spacing:    [0,0,0,0],
      height:     800, // set a large height default value to avoid incorrect legendHeight value

      events: {
        load: function() {
          const pie_chart_plot_area_height = 153
          const pie_chart_width = parseFloat($target_pie_chart_container.find(".highcharts-plot-background").attr("width") || "0")

          this.setSize(null, this.legend.legendHeight + pie_chart_plot_area_height)
          this.setTitle({
            x: (pie_chart_width + chart_title_width - this.chartWidth) / 2.0,
            y: (pie_chart_plot_area_height - this.chartHeight) / 2 + 10,
          })
        },
      },
    },
    title:     {
      text:           title_translation,
      verticalAlign:  "middle",
      align:          "center",
      width:          chart_title_width,
      style:          {
        textAlign:  "center",
        fontSize:   14,
      },
    },
    credits:  {
      enabled: false,
    },

    tooltip: {
      useHTML:          true,
      followPointer:    true,
      backgroundColor:  null,
      borderWidth:      0,
      shadow:           false,
      style:            {
        padding: 0,
      },
      formatter: function() {
        const self = this as unknown as Highcharts.Point

        return tooltip_tmpl({
          name:   self.key,
          color:  self.color,
          y:      (self.y || 0).toFixed(1) + "%",
        })
      },
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    legend:   {
      labelFormatter: function(){
        // this value NOT defined coz depends on chart type
        // For pie chart it's point object
        const self = this as unknown as Highcharts.Point

        return legend_tmpl({
          name: self.name,
          y:    (self.y || 0).toFixed(1) + "%",
        })
      },
      layout:           "vertical",
      useHTML:          true,
      itemMarginBottom: 10,
      itemMarginTop:    10,
      itemMarginLeft:   0,

      symbolHeight: 10,
      symbolWidth:  10,
      symbolRadius: 5,

      x:         0, // default spacing left is 10 for pie chart
      itemStyle: {
        fontSize:   "12px",
        fontWeight: "normal",
        fontFamily: "Lato",
        textAlign:  "left",
      },
    },
    plotOptions: {
      pie: {
        size:             117,
        allowPointSelect: false,
        cursor:           "pointer",
        dataLabels:       {
          enabled:        false,
        },

        showInLegend:     true,
        innerSize:        93,
        borderRadius:     0,
        borderColor:      null,
        slicedOffset:     0,
        states:           {
          hover: {
            // https://www.highcharts.com/forum/viewtopic.php?t=47571, set halo to null to disable outer shadow
            halo:       null,
            brightness: 0,
          },
        },
      },
    },
    series: [{
      name:         title_translation,
      type:         "pie",
      colorByPoint: true,
      data:         data_collection.map((e, index) => {
        const point_options = {
          name:   e.category_name,
          y:      e.category_value,
          color:  point_colors_collection[index],
          events:
          {
            legendItemClick:  (event: Event) => {
              event.preventDefault()
            },
          },
        }

        return point_options
      }),
    }],

  })

}

export default {create}
